import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { submit, closeModal } from './modules'
import Loading from 'components/Loading'
import { queryNotice, queryAgreements, checkIsLogin } from 'store/siteConfig'

export default function(route) {
  const AddSessionBankCard = Loadable({
    loader: () => import('./AddSessionBankCard'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          bankCardAddSessionBankCardState:
            state.bankCardAddSessionBankCardState,
          siteConfig: state.siteConfig,
        }),
        {
          checkIsLogin,
          submit,
          closeModal,
          queryNotice,
          queryAgreements,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/add-session-bank-card`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <AddSessionBankCard {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
